import { z } from 'zod';

/** Screen position for the floating sticky note (desktop). */
export interface MemberContextNotePositionDto {
  x: number;
  y: number;
}

/** Team-visible member context note with server-persisted layout. */
export interface MemberContextNoteDto {
  memberId: string;
  body: string | null;
  isMinimized: boolean;
  position: MemberContextNotePositionDto | null;
  bodyHeightPx: number | null;
  lastUpdatedAt: string | null;
  lastUpdatedByUserId: string | null;
  uiLastUpdatedAt: string | null;
  uiLastUpdatedByUserId: string | null;
}

export const MemberContextNotePositionSchema = z.object({
  x: z.number(),
  y: z.number(),
});

/** Partial update for member context note body and/or layout. */
export const PatchMemberContextNoteSchema = z.object({
  body: z.string().nullable().optional(),
  isMinimized: z.boolean().optional(),
  position: MemberContextNotePositionSchema.nullable().optional(),
  bodyHeightPx: z.number().positive().nullable().optional(),
});

export type PatchMemberContextNoteRequestDto = z.infer<
  typeof PatchMemberContextNoteSchema
>;

/** Summary row for member context note revision history. */
export interface MemberContextNoteRevisionListItemDto {
  id: string;
  validFrom: string;
  validTo: string | null;
  updatedAt: string;
  createdByUserId: string | null;
  bodyPreview: string;
  isCurrent: boolean;
}

/** Full body snapshot for a single revision. */
export interface MemberContextNoteRevisionDto extends MemberContextNoteRevisionListItemDto {
  body: string;
}

/** Paginated revision history list. */
export interface MemberContextNoteRevisionListResponseDto {
  items: MemberContextNoteRevisionListItemDto[];
  total: number;
}

export const MemberContextNoteHistoryQuerySchema = z.object({
  limit: z.coerce.number().int().positive().max(100).optional().default(25),
  offset: z.coerce.number().int().min(0).optional().default(0),
});

export type MemberContextNoteHistoryQueryDto = z.infer<
  typeof MemberContextNoteHistoryQuerySchema
>;
